/**
 * INVENTA API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PaymentAccountSimpleDto } from './paymentAccountSimpleDto';
import { InvoiceSimpleDto } from './invoiceSimpleDto';
import { UserAccountLightDto } from './userAccountLightDto';


export interface InvoiceSuggestionDto { 
    paymentAccount?: PaymentAccountSimpleDto;
    paymentAccountOwners?: Array<UserAccountLightDto>;
    prePayment?: boolean;
    balance?: number;
    currency?: InvoiceSuggestionDto.CurrencyEnum;
    lastInvoice?: InvoiceSimpleDto;
    lastMonthFee?: number;
    invoiceAmountSuggestion?: number;
    currentlyActiveComTypes?: Array<InvoiceSuggestionDto.CurrentlyActiveComTypesEnum>;
    suggestionFinalInvoice?: boolean;
}
export namespace InvoiceSuggestionDto {
    export const CurrencyEnum = {
        Usd: 'USD',
        Eur: 'EUR',
        Cad: 'CAD'
    } as const;
    export type CurrencyEnum = typeof CurrencyEnum[keyof typeof CurrencyEnum];
    export const CurrentlyActiveComTypesEnum = {
        Iridium: 'IRIDIUM',
        Globalstar: 'GLOBALSTAR',
        NbIot: 'NB_IOT',
        NoCommunication: 'NO_COMMUNICATION',
        Gsm: 'GSM'
    } as const;
    export type CurrentlyActiveComTypesEnum = typeof CurrentlyActiveComTypesEnum[keyof typeof CurrentlyActiveComTypesEnum];
}


export type CurrentlyActiveComTypesEnum = typeof InvoiceSuggestionDto.CurrentlyActiveComTypesEnum[keyof typeof InvoiceSuggestionDto.CurrentlyActiveComTypesEnum];
